import {
    GET_GC_LIST,
    DELETE_GC,
    GET_GC_DETAIL,
    POST_GC_CREATE,
} from "./GastoCorrienteAction";

let initialState = {

    getGCList: false,
    errorGCList: false,
    getGCDetail: false,
    errorGCDetail: false,

    getResponDataGC: false,
    errorResponDataGC: false,
    getGCBorrar: false,
    errorGCBorrar: false,
};

const GastoCorrienteReducer = (state = initialState, action) => {
    //console.log(action.type);

    switch (action.type) {

        case GET_GC_LIST:
            return {
                ...state,
                getGCList: action.payload.data,
                errorGCList: action.payload.errorMessage,
            };

        case DELETE_GC:
            return {
                ...state,
                getGCBorrar: action.payload.data,
                errorGCBorrar: action.payload.errorMessage,
            };

        case GET_GC_DETAIL:

            return {
                ...state,
                getGCDetail: action.payload.data,
                errorGCDetail: action.payload.errorMessage,
            };
        case POST_GC_CREATE:
            return {
                ...state,
                getResponDataGC: action.payload.data,
                errorResponDataGC: action.payload.errorMessage,
            };

        default:
            return state;


    }//END SWITCH

}//END FUNCTION

export default GastoCorrienteReducer;